import React from "react";
import "./Features.css";
import Layout from '../PageLayout/Layout';
import TrustStrip from "../shared/TrustStrip";

export default function Features() {
  return (
    <>
      {/* Mobile UI — unchanged Key Features */}
      <section className="features-section features-mobile">
        <Layout>
          <div className="container">
            <p className="section-label text-center"><img src="/icons/bolt.svg" alt="bolt Icon"/>Key Features</p>
            <h2 className="features-heading">Powerful intelligence. Simple control.</h2>
            <p className="features-subtext">
              Highwatch unifies data, documents, and workflows into one secure intelligence layer, turning enterprise knowledge into traceable, compliant action.
            </p>

            <div className="features-grid">
              <div className="feature-card boxed">
                <div className="feature-icon"><img src="/icons/greenbrain.svg" alt = "Green brain Icon"/></div>
                <h3 className="feature-title">Connected Knowledge Graph</h3>
                <p className="feature-desc">
                  Highwatch securely connects every system, Salesforce, ServiceNow, SharePoint, SAP, and more, into a unified knowledge graph. Search across structured and unstructured data instantly, without moving or duplicating it.
                </p>
              </div>

              <div className="feature-card boxed">
                <div className="feature-icon"><img src="/icons/greennotes.svg" alt="Green Notes Icon"/></div>
                <h3 className="feature-title">Compliance-Aware Intelligence</h3>
                <p className="feature-desc">
                  Every answer Highwatch provides is grounded in your organization’s verified policies, SOPs, and controls. It understands context, ensuring that recommendations always meet internal and external compliance standards.
                </p>
              </div>

              <div className="feature-card boxed">
                <div className="feature-icon"><img src="/icons/greencirclearrow.svg" alt="Green Circle Arrow Icon"/></div>
                <h3 className="feature-title">Continuous Sync & Version Control</h3>
                <p className="feature-desc">
                  Your data stays live and accurate. Highwatch auto-syncs updates from connected systems, tracks document versions, and prevents knowledge drift, no manual uploads, ever.
                </p>
              </div>

              <div className="feature-card boxed">
                <div className="feature-icon"><img src="/icons/greenclockarrow.svg" alt="Green Clock Arrow Icon"/></div>
                <h3 className="feature-title">Full Audit & Traceability</h3>
                <p className="feature-desc">
                  Every query, response, and workflow action is logged with full traceability, including time, source, and user context. Corelink’s audit trail provides the accountability and transparency enterprises need for governance and reporting.
                </p>
              </div>
            </div>
          </div>
        </Layout>
      </section>

      {/* Desktop web UI — Why Highwatch + trust bar */}
      <div className="hw-why-wrap">
        <TrustStrip />

        <section id="why-highwatch" className="hw-why">
          <div className="hw-why__header">
            <p className="hw-why__eyebrow">WHY HIGHWATCH</p>
            <h2 className="hw-why__title">Every decision, explained.</h2>
            <p className="hw-why__subtitle">
              Not just an answer — the evidence, the confidence, and the audit trail behind it.
              Hover the evidence tags below.
            </p>
          </div>

          <div className="hw-why__grid">
            <article className="hw-why-card hw-why-card--dark">
              <h3>Every AI recommendation comes with its reasoning</h3>
              <p>No black-box decisions. Underwriters see exactly what the model saw, and why.</p>

              <div className="hw-why-snippet">
                <div className="hw-why-snippet__top">
                  <span className="hw-why-snippet__id">sub_a1d645cf</span>
                  <span className="hw-why-snippet__status">UNDER REVIEW</span>
                </div>
                <div className="hw-why-snippet__body">
                  <div className="hw-why-gauge" aria-hidden="true">
                    <svg viewBox="0 0 96 96">
                      <circle cx="48" cy="48" r="38" className="hw-why-gauge__track" />
                      <circle cx="48" cy="48" r="38" className="hw-why-gauge__value" />
                    </svg>
                    <div className="hw-why-gauge__label">
                      <strong>23</strong>
                    </div>
                  </div>
                  <div className="hw-why-snippet__meta">
                    <span className="hw-why-snippet__meta-label">Portfolio risk</span>
                    <span className="hw-why-snippet__meta-value">Low risk</span>
                  </div>
                </div>
                <div className="hw-why-tags">
                  <button type="button" className="hw-why-tag">Coverage risk</button>
                  <button type="button" className="hw-why-tag">Payment risk</button>
                  <button type="button" className="hw-why-tag">Model confidence</button>
                </div>
              </div>
            </article>

            <div className="hw-why__side">
              <article className="hw-why-card hw-why-card--light">
                <div className="hw-why-card__icon" aria-hidden="true">
                  <span className="hw-why-card__dice" />
                </div>
                <h3>Risk scoring, in real time</h3>
                <p>
                  Fraud, severity, and leakage scored continuously — flagging what needs
                  investigation before payout, not after.
                </p>
              </article>

              <article className="hw-why-card hw-why-card--light">
                <div className="hw-why-card__icon" aria-hidden="true">
                  <span className="hw-why-card__dice" />
                </div>
                <h3>Role-based access</h3>
                <p>
                  Underwriters, adjusters, managers, and auditors each see exactly what their
                  role permits.
                </p>
              </article>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
